export const scriptsHead = [
  // {
  //   src: 'https://site.com/script.js',
  //   defer: true,
  //   async: true,
  //   hid: 'script-id',
  // },
];
